export const FETCH_PRODUCT = 'productPage/FETCH_PRODUCT';
export const UPDATE_PRODUCT = 'product/UPDATE';
